// src/function.ts
function createCurriedGuardPredicate(basePredicate) {
  return (predicate) => (v) => basePredicate(v) && predicate(v);
}
function pipe(a, ab, bc, cd, de, ef, fg) {
  switch (arguments.length) {
    case 1:
      return a;
    case 2:
      return ab(a);
    case 3:
      return bc(ab(a));
    case 4:
      return cd(bc(ab(a)));
    case 5:
      return de(cd(bc(ab(a))));
    case 6:
      return ef(de(cd(bc(ab(a)))));
    case 7:
      return fg(ef(de(cd(bc(ab(a))))));
    default: {
      return [ab, bc, cd, de, ef, fg].reduce((acc, fn) => {
        if (!!fn)
          return fn(acc);
        return acc;
      }, a);
    }
  }
}
function tryOr(fn, or) {
  try {
    return fn();
  } catch (e) {
    return or;
  }
}

// src/string.ts
function str(s) {
  return new TslyStr(s);
}
var TslyStr = class extends String {
  escapeRegex() {
    return str(
      this.replace(/[\-\[\]\/\{}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
    );
  }
  sliceTo(to, nth = 0) {
    const sliced = this.slice(0, this.indexOf(to) + to.length);
    if (sliced == "")
      return this;
    if (nth == 0)
      return str(sliced);
    else
      return str(sliced + str(this.slice(sliced.length)).sliceTo(to, nth - 1));
  }
  capitalize() {
    if (this.take() == "")
      return this;
    return str(this.at(0).toUpperCase() + this.slice(1).toLowerCase());
  }
  maybeParseInt(radix) {
    const parsed = parseInt(this.take(), radix);
    return isNaN(parsed) ? null : parsed;
  }
  maybeParseFloat() {
    const parsed = parseFloat(this.take());
    return isNaN(parsed) ? null : parsed;
  }
  take() {
    return this.slice(0);
  }
};

// src/errors.ts
function err(error) {
  throw typeof error == "string" ? new Error(error) : error;
}
export {
  createCurriedGuardPredicate,
  err,
  pipe,
  str,
  tryOr
};
